import { useTranslation } from 'react-i18next';
import EmployeeSelect from './EmployeeSelect.component';
import { SpecificEmployeeSelectProps } from './types';

const HR_GROUP_KEY = 'hr';

const HRSelect = ({
  value,
  onChange,
  isMulti = false,
  isRequired = false,
  menuPlacement = 'auto',
  useMenuPortalTarget = false,
  validationFailureMessage,
  notAssignItem = false,
}: SpecificEmployeeSelectProps) => {
  const { t } = useTranslation();

  const translatedHRTitle = t('HR');
  const translatedHRPlaceholder = t('Choose HR');
  const label = isRequired ? `${translatedHRTitle} *` : `${translatedHRTitle}`;

  return (
    <EmployeeSelect
      label={label}
      placeholder={translatedHRPlaceholder}
      value={value}
      onChangeOption={onChange}
      specificGroupFilter={HR_GROUP_KEY}
      isFilteredByRegionIntersection
      isMulti={isMulti}
      menuPlacement={menuPlacement}
      useMenuPortalTarget={useMenuPortalTarget}
      validationFailureMessage={validationFailureMessage}
      notAssignItem={notAssignItem}
    />
  );
}

export default HRSelect;
